import React, { useState, useEffect, useContext } from "react";

// Création du contexte avec une valeur par défaut
const ContextOnlineStatus = React.createContext(true);

export const OnlineStatusProvider = ({ children }) => {
  const [onlineStatus, setOnlineStatus] = useState(navigator.onLine); // Vérifie l'état initial

  // Définition des gestionnaires en dehors de useEffect pour éviter le bug
  const handleOnline = () => setOnlineStatus(true);
  const handleOffline = () => setOnlineStatus(false);

  useEffect(() => {
    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  return (
    <ContextOnlineStatus.Provider value={onlineStatus}>
      {children}
    </ContextOnlineStatus.Provider>
  );
};

// Hook personnalisé pour utiliser le contexte facilement
export const useOnlineStatus = () => useContext(ContextOnlineStatus);
